<template>
  <div style="width: 1200px; margin: 0 auto; border-radius: 25px">
    <Title :title="{ name: '审核类型配置', path: '/flow/flow' }"></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table
          :data="tableData"
          :header-cell-style="{
            background: 'rgb(245,245,245)',
            color: 'black',
          }"
          :cell-style="{ color: 'black' }"
        >
          <el-table-column prop="flowName" label="审批名称" align="center">
          </el-table-column>
          <el-table-column prop="flowPath" label="详情路径" align="center">
          </el-table-column>
          <el-table-column prop="creatTime" label="配置时间" align="center">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="openAddCopy(scope.row.flowId)"
                >添加抄送</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 100%">
          <div style="float: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="param.current"
              :page-sizes="sizes"
              :page-size="param.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="添加抄送人"
      :visible.sync="dialogFormVisible"
      width="40%"
      :close-on-click-modal="false"
      :before-close="shutOff"
    >
      <el-transfer
        filterable
        filter-placeholder="请输入名字"
        v-model="copyUserList"
        :data="data"
        :titles="['全部员工', '已选员工']"
      >
      </el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shutOff">取 消</el-button>
        <el-button type="primary" @click="addCopy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Title from "../../Title";
import { requestFlowGrid } from "../../../api";

export default {
  components: { Title },
  data() {
    return {
      // 默认显示第几页
      param: {
        current: 1,
        size: 5,
      },
      totalCount: 0,
      sizes: [5, 10, 15, 20],
      flowName: "",
      tableData: [],
      dialogFormVisible: false,
      flowId: 0,
      copyUserList: [],
      data: [],
    };
  },
  methods: {
    handleSizeChange(val) {
      this.param.size = val;
      this.param.current = 1;
      this.getData();
    },
    shutOff() {
      this.copyUserList = [];
      this.flowId = 0;
      this.dialogFormVisible = false;
    },
    addCopy() {},
    getAllCount() {},
    openAddCopy(flowId) {
      this.flowId = flowId;
      this.dialogFormVisible = true;
    },

    // 显示第几页
    handleCurrentChange(val) {
      this.param.current = val;
      this.getData();
    },
    async getData() {
      const res = await requestFlowGrid(this.param);
      if (res.code == 200) {
        this.tableData = res.rows;
        this.totalCount = res.total;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
  created() {
    this.getData();
    this.getAllCount();
  },
};
</script>
